import { doMutation } from "../../core-module/util/graphqlHelper";
import { onLogin } from "../../../plugins/vue-apollo";
import { deviceId } from "../helpers/authHelper";

export const signUp = (signUpInput, isComplete, token) => {
  const mutation = require("../api/mutation/signUp.gql");
  const variables = {
    input: {
      ...signUpInput,
      deviceId: deviceId(),
    },
    token: token,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      if (isComplete) onLogin(data.signUp);
      return { data: data.signUp };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
